import Vue from "vue";
import Router from "vue-router";
// import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      meta: { offlineAvailability: false, fullscreen: true },
      component: () =>
        import(/* webpackChunkName: "home" */ "../views/Home.vue")
    },
    {
      path: "/competition/:competitions_id/wavesResults",
      name: "competitionsWavesResults",
      meta: { offlineAvailability: false, fullscreen: true },
      component: () =>
        import(
          /* webpackChunkName: "competitionsWavesResults" */ "../views/LiveResults.vue"
        )
    }
  ]
});
